import React, { useCallback, useEffect, useMemo, useState } from 'react';
import StepList from '../step-list/StepList';
import VideoQuiz from '../video-quiz/VideoQuiz';
import ReadAndAccept from '../read-and-accept/ReadAndAccept';
import { History } from 'history';
import HorizontalNumberStepper from '../step-list/HorizontalNumberStepper';
import { syncCurrentStepFromServer, incrementStep, getMaxClickableStepIndex, setStepIndex } from './currentStepManager';
import t from 'rcm-i18n';
import { StepConfig, BlockConfig } from '../../types';
import { Congratulations } from '../congratulations/Congratulations';
import { WelcomeStep } from '../welcome/WelcomeStep';
import './StepRoute.scss';
interface Props {
    steps: StepConfig[];
    stepIndex: number;
    history: History;
    config: BlockConfig;
}

const StepRoute = ({ steps, stepIndex, history, config }: Props) => {
    const [httpErrorOccurred, setHttpErrorOccurred] = useState(false);

    useEffect(() => {
        syncCurrentStepFromServer(stepIndex, steps, history);
    }, [stepIndex, steps, history]);

    const handleContinueToNextStep = useCallback(
        () => {
            setHttpErrorOccurred(false);
            incrementStep(stepIndex, steps, history).catch((e) => {
                setHttpErrorOccurred(true);
            });
        },
        [stepIndex, steps, history, setHttpErrorOccurred]
    );

    const handleSelectStep = useCallback(
        (stepIndex) => {
            setHttpErrorOccurred(false);
            setStepIndex(stepIndex, steps, history).catch((e) => {
                setHttpErrorOccurred(true);
            });
        },
        [stepIndex, steps, history, setHttpErrorOccurred]
    );

    const currentStep = steps[stepIndex];

    const maxClickableStepIndex = useMemo(getMaxClickableStepIndex, []);
    return <>
        {stepIndex < steps.length &&
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <h1>{currentStep.headingText}</h1>
                    </div>
                </div>
                {httpErrorOccurred &&
                    <div className="alert alert-warning" role="alert">
                        {t('An error occurred while communicating with servers.'
                            + ' Please ensure you are logged in and connected to the internet.'
                            + ' Then try again.')}
                    </div>
                }
                <div className="row">
                    <div className="col-sm-12">
                        <div style={{ display: 'table', width: '100%' }}>
                            <div style={{ display: 'table-row' }}>
                                <div className="main-table-cell">
                                    {currentStep.stepType === 'videoWithQuiz' &&
                                        <VideoQuiz videoWithQuizStep={currentStep} stepIndex={stepIndex}
                                            onContinueToNextStep={handleContinueToNextStep} />
                                    }
                                    {currentStep.stepType === 'readAndAccept' &&
                                        <ReadAndAccept readAndAcceptStep={currentStep}
                                            onContinueToNextStep={handleContinueToNextStep} />
                                    }
                                    {currentStep.stepType === 'congratulations' &&
                                        <Congratulations step={currentStep} />
                                    }
                                    {currentStep.stepType === 'welcome' &&
                                        <WelcomeStep step={currentStep} onContinue={handleContinueToNextStep} />
                                    }
                                </div>
                                <div className="sidebar-table-cell hidden-xs">
                                    <StepList steps={steps}
                                        stepIndex={stepIndex}
                                        maxClickableStep={maxClickableStepIndex}
                                        onStepSelect={handleSelectStep}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 horizontal-stepper-container">
                        <HorizontalNumberStepper steps={steps} stepIndex={stepIndex} />
                    </div>
                    <div className="col-sm-12">
                        <div className="xs-horizontal-stepper-container">
                            {'Step ' + (stepIndex + 1) + ' of ' + steps.length}
                        </div>
                    </div>
                </div>
            </div>
        }
    </>;
};

export default StepRoute;
